const urlPartsSeparator = '.';
export class UrlTenantHandlerService {
    static $inject = ['BLIP_DOMAIN_URL'];
    constructor(BLIP_DOMAIN_URL) {
        this.BLIP_DOMAIN_URL = BLIP_DOMAIN_URL;
    }
    addTenantPrefixToUrl(url, tenantId = undefined, defaultUrl = undefined) {
        tenantId = tenantId ?? this.getTenantPrefixFromUrl();
        defaultUrl = defaultUrl ?? url;
        try {
            if (tenantId) {
                const treatedUrl = new URL(url);
                if (treatedUrl.host.split(urlPartsSeparator)[0] !== tenantId) {
                    return `${treatedUrl.protocol}//${tenantId}.${treatedUrl.host}/`;
                }
                else {
                    return `${treatedUrl.protocol}//${treatedUrl.host}/`;
                }
            }
            else {
                const treatedDefaultUrl = new URL(defaultUrl);
                return `${treatedDefaultUrl.protocol}//${treatedDefaultUrl.host}/`;
            }
        }
        catch (e) {
            return tenantId ? `${tenantId}.${url}` : defaultUrl;
        }
    }
    getTenantPrefixFromUrl() {
        return this.BLIP_DOMAIN_URL.includes(location.origin)
            ? undefined
            : location.hostname.split(urlPartsSeparator)[0];
    }
}
UrlTenantHandlerService.$inject = ['BLIP_DOMAIN_URL'];
